"use strict";

const NewTab = {
  add: (app) => {
    app.ports.open.subscribe((url) => window.open(url, "_blank"));
  },
};

module.exports = NewTab;
